<template>
  <div class="col d-flex justify-content-center">
    <div class="card">
      <div class="card-body">
        <h3 class="card-title">Down for Maintenance</h3>
        <div class="col-12">
          <p>
            The site is currently undergoing scheduled maintenance. Please check back shortly.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Maintenance",
};
</script>
